<template>
  <v-layout>
    <v-btn outlined icon :color="color"
      @click.native="playing ? pause() : play()" :disabled="!loaded" class="mr-2">
      <v-icon color="#454545" size="30" v-if="!playing || paused">play_arrow
      </v-icon>
      <v-icon color="#454545" size="26" v-else>pause</v-icon>
    </v-btn>
    <v-layout column>
      <v-slider v-model="percentage" min="0" max="100" @click="setPosition">
      </v-slider>
      <span class="duration" v-if="playing">{{ currentTime }}</span>
      <span class="duration" v-else>{{ duration }}</span>
    </v-layout>

    <v-btn
      v-if="showSpeed && playing"
      :disabled="!loaded"
      @click="changePlaybackRate"
      class="ml-2 mt-1"
      elevation="0"
      rounded
      small
      title="Mudar a velocidade"
    >
      {{ playbackRate }}x
    </v-btn>

    <audio id="player" ref="player" v-on:ended="ended" v-on:canplay="canPlay"
      :src="file"></audio>
  </v-layout>
</template>
<script>
const formatTime = second => new Date(second * 1000).toISOString().substr(11, 8);
export default {
  name: 'vuetify-audio',
  props: {
    file: {
      type: String,
      default: null
    },
    showSpeed: {
      type: Boolean,
      default: false,
    },
    autoPlay: {
      type: Boolean,
      default: false
    },
    ended: {
      type: Function,
      default: () => { },
    },
    canPlay: {
      type: Function,
      default: () => { },
    },
    color: {
      type: String,
      default: null
    },
    downloadable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    duration: function () {
      return this.audio ? formatTime(this.totalDuration) : ''
    },
  },
  data() {
    return {
      firstPlay: true,
      isMuted: false,
      loaded: false,
      playbackRate: 1.0,
      playing: false,
      paused: false,
      percentage: 0,
      currentTime: '00:00:00',
      audio: undefined,
      totalDuration: 0,
    }
  },
  methods: {
    changePlaybackRate() {
      if (this.playbackRate === 1.0) {
        this.playbackRate = 1.5;
      } else if (this.playbackRate === 1.5) {
        this.playbackRate = 2.0;
      } else {
        this.playbackRate = 1.0;
      }

      this.audio.playbackRate = this.playbackRate;
    },
    setPosition() {
      this.audio.currentTime = parseInt(this.audio.duration / 100 * this.percentage);
    },
    stop() {
      this.paused = this.playing = false
      this.audio.pause()
      this.audio.currentTime = 0
    },
    play() {
      if (this.playing) return
      this.audio.play().then(() => this.playing = true)
      this.paused = false
    },
    pause() {
      this.paused = !this.paused;
      (this.paused) ? this.audio.pause() : this.audio.play()
    },
    download() {
      this.audio.pause()
      window.open(this.file, 'download')
    },
    mute() {
      this.isMuted = !this.isMuted
      this.audio.muted = this.isMuted
      this.volumeValue = this.isMuted ? 0 : 75
    },
    reload() {
      this.audio.load();
    },
    _handleLoaded: function () {
      if (this.audio.readyState >= 2) {
        if (this.audio.duration === Infinity) {
          // Fix duration for streamed audio source or blob based
          // https://stackoverflow.com/questions/38443084/how-can-i-add-predefined-length-to-audio-recorded-from-mediarecorder-in-chrome/39971175#39971175
          this.audio.currentTime = 1e101;
          this.audio.ontimeupdate = () => {
            this.audio.ontimeupdate = () => { }
            this.audio.currentTime = 0
            this.totalDuration = parseInt(this.audio.duration)
            this.loaded = true;
          }
        } else {
          this.totalDuration = parseInt(this.audio.duration)
          this.loaded = true
        }
        if (this.autoPlay) this.audio.play()
      } else {
        throw new Error('Failed to load sound file')
      }
    },
    _handlePlayingUI: function () {
      this.percentage = this.audio.currentTime / this.audio.duration * 100
      this.currentTime = formatTime(this.audio.currentTime)
      this.playing = true
    },
    _handlePlayPause: function (e) {
      if (e.type === 'play' && this.firstPlay) {
        // in some situations, audio.currentTime is the end one on chrome
        this.audio.currentTime = 0;
        if (this.firstPlay) {
          this.firstPlay = false;
        }
      }
      if (e.type === 'pause' && this.paused === false && this.playing === false) {
        this.currentTime = '00:00:00'
      }
    },
    _handleEnded() {
      this.paused = this.playing = false;
    },
    init: function () {
      this.audio.addEventListener('timeupdate', this._handlePlayingUI);
      this.audio.addEventListener('loadeddata', this._handleLoaded);
      this.audio.addEventListener('pause', this._handlePlayPause);
      this.audio.addEventListener('play', this._handlePlayPause);
      this.audio.addEventListener('ended', this._handleEnded);
    },
  },
  mounted() {
    this.audio = this.$refs.player;
    this.init();
  },
  beforeDestroy() {
    this.audio.removeEventListener('timeupdate', this._handlePlayingUI)
    this.audio.removeEventListener('loadeddata', this._handleLoaded)
    this.audio.removeEventListener('pause', this._handlePlayPause)
    this.audio.removeEventListener('play', this._handlePlayPause)
    this.audio.removeEventListener('ended', this._handleEnded);
  }
}
</script>
<style lang="scss">
.v-input--slider {
  margin: 8px 10px 0px 10px;

  .v-input__slot {
    margin: 0;
  }

  .v-messages {
    display: none;
  }
}

.duration {
  color: #8a8a8a;
  font-size: 11px;
  margin: -10px 0px 5px 7px;
  // text-align: end;
}
</style>